export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="bg-background-100 rounded-lg p-8 md:p-10 flex flex-col lg:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
            <i className="ri-mail-send-line text-2xl md:text-3xl"></i>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-lg md:text-2xl text-foreground-950 mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xl">
              如果你有漫画投稿需求、商务合作意向，或者在使用过程中遇到了任何问题，欢迎通过邮件与我们取得联系。酷漫屋团队会在工作日内尽快回复你的每一封来信。
            </p>
          </div>

          <div className="flex-shrink-0 flex flex-col sm:flex-row gap-3">
            <a
              href="#contact"
              className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              投稿与合作
            </a>
            <a
              href="#contact"
              className="px-6 py-2.5 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-md hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              反馈建议
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}